// What the logged-in person may refund and discount, as set by the Admin, for the strip on the settlement screen.
// The server enforces every limit; this only explains them before the person tries.

const rupees = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

// The server sends -1 for "no daily cap".
const leftToday = (remaining, cap) => {
  if (!(cap > 0)) return { text: '', used: false };
  return { text: ` · ${rupees(remaining)} left today of ${rupees(cap)}`, used: remaining <= 0 };
};

export const limitsView = (a) => {
  if (!a) return null;

  const refund = (() => {
    if (!a.canRefund) return { text: 'You cannot give refunds', tone: 'off' };
    const left = leftToday(a.refundRemainingToday, a.dailyRefundLimit);
    return { text: `Up to ${rupees(a.maxRefundPerTransaction)} per refund${left.text}`, tone: left.used ? 'used' : 'ok' };
  })();

  const discount = (() => {
    if (!a.hasDiscountAuthority) return { text: 'You cannot give discounts', tone: 'off' };
    const parts = [];
    if (a.maxDiscountPerBillPercent > 0) parts.push(`${Number(a.maxDiscountPerBillPercent)}%`);
    if (a.maxDiscountPerBillAmount > 0) parts.push(rupees(a.maxDiscountPerBillAmount));
    const perBill = parts.length ? `Up to ${parts.join(' or ')} per bill` : 'No per-bill limit set';
    const left = leftToday(a.discountRemainingToday, a.dailyDiscountLimit);
    return { text: `${perBill}${left.text}`, tone: left.used ? 'used' : 'ok' };
  })();

  return { refund, discount };
};
